import { Alert } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useRef, useState } from "react";

interface Props {
  url: string | null;
  showError: boolean;
  errorMessage: string;
  className?: string;
}

export default function SharedUrlBox(props: Props) {
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const textRef = useRef<HTMLDivElement>(null);

  function copyToClipboard() {
    if (textRef.current) {
      navigator.clipboard
        .writeText(
          textRef.current.querySelector("#shared-url")?.textContent ?? "",
        )
        .then(() => {
          setIsCopied(true);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  }

  if (props.showError) {
    return <Alert severity="error">{props.errorMessage}</Alert>;
  }

  if (!props.url) {
    return null;
  }

  return (
    <div
      ref={textRef}
      onClick={copyToClipboard}
      className={`font-skyRegular p-2 bg-blue-100 border border-blue-300 rounded-md cursor-pointer hover:bg-blue-200 transition-colors ${props.className ?? ""}`}
      title="Click to copy url"
    >
      <ContentCopyIcon className="mr-4" />
      <span id="shared-url">{props.url}</span>
      <span
        className={`float-right text-blue-500 font-skyBold ${
          isCopied ? "block" : "hidden"
        }`}
      >
        copied
      </span>
    </div>
  );
}
